/** 一张贴纸最多 3 个 emoji。点已选中的会取消，点新的会加上，满 3 个就不再加。 */

export const STICKER_EMOJI_LIMIT = 3

/** AI 从这份清单为每张贴纸选择 1～3 个。改这里要同时改 StickerZipApplier 的 EMOJI_PALETTE。 */
export const STICKER_EMOJI_PALETTE = [
  '😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊',
  '😋', '😎', '😍', '😘', '😗', '😙', '😚', '🙂', '🤗', '🤩',
  '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮',
  '🤐', '😯', '😪', '😫', '😴', '😌', '😛', '😜', '😝', '🤤',
  '😒', '😓', '😔', '😕', '🙃', '🤑', '😲', '☹️', '🙁', '😖',
  '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '🤯',
  '😬', '😰', '😱', '🥵', '🥶', '😳', '🤪', '😵', '😡', '😠',
  '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '😇', '🤠', '🤡',
  '🥳', '🥴', '🥺', '🤥', '🤫', '🤭', '🧐', '🤓', '😈', '👿',
  '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤏', '✌️', '🤞', '🤟',
  '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎',
  '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '❣️',
  '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '🔥', '✨',
  '⭐', '🌟', '💯', '💢', '💥', '💫', '💦', '💨', '🎉', '🎊',
]

export function toggleStickerEmoji(current, emoji) {
  const list = Array.isArray(current) ? current.slice() : []
  const index = list.indexOf(emoji)
  if (index >= 0) {
    list.splice(index, 1)
    return list
  }
  if (list.length >= STICKER_EMOJI_LIMIT) {
    return list
  }
  list.push(emoji)
  return list
}
